import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {useLocation, useParams, useNavigate} from "react-router-dom";
import {RequestStatus} from "../../utils/Enums";
import {
    deleteOfflineReason,
    getCurrentOfflineReason,
    resetDeleteOfflineReasonStatus,
} from "../../store/reducers/OfflineReasonsSlice";
import Breadcrumbs from "../common/Breadcrumbs";
import {LoggedInView} from "../common/LoggedInView";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";

interface DeleteOfflineReasonsScreenProps {
}

export const DeleteOfflineReasonScreen: React.FC<DeleteOfflineReasonsScreenProps> = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const offlineReasonsState = useAppSelector(
        (state) => state.offlineReasons
    );
    const requestStatus: RequestStatus =
        offlineReasonsState.deleteOfflineReasonStatus;

    const {id} = useParams();

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "Miks väljas põhjused", url: "/offline-reasons"},
        {text: "Miks väljas põhjuse kustutamine", url: `/offline-reasons/${id}/delete`,},
    ];

    useEffect(() => {
        dispatch(resetDeleteOfflineReasonStatus());
    }, [location]);

    const handleConfirm = () => {
        dispatch(deleteOfflineReason({id}));
    };

    const handleCancel = () => {
        navigate(-1);
    };

    useEffect(() => {
        dispatch(getCurrentOfflineReason({id}));
    }, [id]);

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    <h2>Miks väljas põhjus kustutatud</h2>
                </div>
            </div>
        );
    };

    const showConfirm = () => {
        return (
            <div className="message" style={{textAlign: "center"}}>
                <div>
                    <h2>
                        Oled kindel, et soovid põhjuse{" "}
                        <em>{offlineReasonsState?.currentOfflineReason?.name ?? ''}</em>{" "}
                        kustutada?
                    </h2>
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes"/>
                            <button type="button" onClick={handleConfirm}>
                                <span>
                                    <strong>Jah</strong>
                                </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    };

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );
};